/**
 * ChannelGuide – SVG icon.
 */
import Props from '@shared/types/props/pressable';
import Colors from '@shared/assets/style/default/color';
import Screen from '@screen';

/** Channel guide menu icon. */
export default function ChannelGuideIcon({ focused }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${32 * Screen.widthRatio}`}
      height={`${32 * Screen.widthRatio}`}
      viewBox={'0 0 32 32'}
    >
      <path
        d='M3 3V11H11V3H3ZM2 0C0.895431 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14H12C13.1046 14 14 13.1046 14 12V2C14 0.895431 13.1046 0 12 0H2Z'
        clipRule='evenodd'
        fillRule='evenodd'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M3 21V29H11V21H3ZM2 18C0.895431 18 0 18.8954 0 20V30C0 31.1046 0.89543 32 2 32H12C13.1046 32 14 31.1046 14 30V20C14 18.8954 13.1046 18 12 18H2Z'
        clipRule='evenodd'
        fillRule='evenodd'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M21 3V11H29V3H21ZM20 0C18.8954 0 18 0.89543 18 2V12C18 13.1046 18.8954 14 20 14H30C31.1046 14 32 13.1046 32 12V2C32 0.895431 31.1046 0 30 0H20Z'
        clipRule='evenodd'
        fillRule='evenodd'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M21 21V29H29V21H21ZM20 18C18.8954 18 18 18.8954 18 20V30C18 31.1046 18.8954 32 20 32H30C31.1046 32 32 31.1046 32 30V20C32 18.8954 31.1046 18 30 18H20Z'
        clipRule='evenodd'
        fillRule='evenodd'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
    </svg>
  );
}
